import * as React from "react";
import NewEvent from "./NewEvent";
import PostEvent from "../dashboard/PostEvent";
import EventCard from "./EventCard";
import {Button, Stack, Typography} from '@mui/material';
import RemoveRedEyeIcon from "@mui/icons-material/RemoveRedEye";
import Calendar from "../calendar/Calendar";
import Slider from "react-slick";
import {useScreen} from "./hooks/useScreen";
import {useContext, useEffect, useState} from "react";
import {CommunityContext} from "../community/CommunityDetail";
import {useDarkMode} from "../darkMode/hook/useDarkMode";

const EventDashboard = ({events}) => {
    console.log('events', events)
    const {changeScreen} = useScreen();
    const context = useContext(CommunityContext);
    const {mode} = useDarkMode();
    const settings = {
        dots: false,
        infinite: true,
        speed: 500,
        slidesToShow: events.old ? events.old.length < 3 ? events.old.length : 3 : 3,
        centerPadding: '-15px',
        centerMode: true,
        responsive: [
            {
                breakpoint: 1200,
                settings: {
                    slidesToShow: 3,
                    centerPadding: '0px',
                }
            },
            {
                breakpoint: 600,
                settings: {
                    slidesToShow: 1,
                    arrows: false,
                    centerPadding: '0px',
                }
            }
        ],
        variableWidth : false
    };

    const settingsNew = {
        dots: false,
        infinite: true,
        speed: 500,
        slidesToShow: events.new ? events.new.length < 3 ? events.new.length : 3 : 3,
        responsive: [
            {
                breakpoint: 1200,
                settings: {
                    slidesToShow: 3,
                    centerPadding: '0px',
                }
            },
            {
                breakpoint: 600,
                settings: {
                    slidesToShow: 1,
                    arrows: false,
                    centerPadding: '0px',
                }
            }
        ],
        variableWidth : false
    };

    return (
        <Stack
            direction="column"
            justifyContent="left"
            alignItems="stretch"
            spacing={4}
        >
            <NewEvent communityId={context.communityId}></NewEvent>
            <Typography variant={'h3'} style={{color : mode.settings.textColor3}}>
                Evènement à venir
            </Typography>
            {
                events.new &&
                events.new.length > 2 ?
                <Slider {...settingsNew}>
                    {  events.new && events.new.map((theEvent,index) => (
                        <div key={index}>
                            <EventCard
                                theEvent={theEvent}
                                sx={{m: {sx:0, md:1}}}
                            />
                        </div>
                    ))}
                </Slider> :
                <Stack direction={'row'} gap={'34px'}>
                    {  events.new && events.new.map((theEvent,index) => (
                        <div key={index}>
                            <EventCard
                                theEvent={theEvent}
                                sx={{m: {sx:0, md:1}}}
                            />
                        </div>
                    ))}
                </Stack>
            }
            <Stack
                direction="row"
                justifyContent="center"
                alignItems="center"
            >
                <Button
                    className="btn-gradient"
                    variant="contained"
                    size="large"
                    startIcon={<RemoveRedEyeIcon role="img" aria-label={"Voir tous les évènements"} />}
                    sx={{marginTop: 1}}
                    onClick={() => changeScreen(3)}
                    aria-label={"Voir tous les évènements"}
                >
                    <Typography variant={'subtitle3'}>Voir tous les évènements</Typography>
                </Button>
            </Stack>
            {events.old && <Typography variant={'h3'} style={{color : mode.settings.textColor3}}>
                Evènements passés
            </Typography>}
            {
                events.old &&
                events.old.length > 2 ?
                <Slider {...settings}>
                    {  events.old && events.old.map((theEvent,index) => (
                        <div key={index}>
                            <EventCard
                                theEvent={theEvent}
                                sx={{m: {sx:0, md:1}}}
                            />
                        </div>
                    ))}
                </Slider>:
                <Stack direction={'row'} gap={'34px'}>
                    {  events.old && events.old.map((theEvent,index) => (
                        <div key={index}>
                            <EventCard
                                theEvent={theEvent}
                                sx={{m: {sx:0, md:1}}}
                            />
                        </div>
                    ))}
                </Stack>
            }
            {
                events.old &&
                <Stack
                    direction="row"
                    justifyContent="center"
                    alignItems="center"
                >
                    <Button
                        className="btn-gradient"
                        variant="contained"
                        size="large"
                        startIcon={<RemoveRedEyeIcon role="img" aria-label={"Voir tous les évènements passés"} />}
                        sx={{marginTop: 1}}
                        onClick={() => changeScreen(4)}
                        aria-label={"Voir tous les évènements passés"}
                    >
                        <Typography variant={'subtitle3'}>Voir tous les évènements passés</Typography>
                    </Button>
                </Stack>
            }

        </Stack>

    )
}

export default EventDashboard;
